import { Leaf } from "lucide-react";

const LINKS = [
  { label: "Who We Are", href: "#about" },
  { label: "Feed Ingredients", href: "#feed" },
  { label: "Spices", href: "#spices" },
  { label: "Tea", href: "#tea" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-[#3D2817] bg-[#EFE4B8] py-16"
  >
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#3D2817] text-[#3D2817]">
              <Leaf size={20} strokeWidth={1.5} />
            </span>
            <span className="font-display text-2xl tracking-tight text-[#3D2817]">
              Agro Trade Global
            </span>
          </div>
          <p className="mt-5 text-base italic leading-relaxed text-[#6B4423] font-display text-xl">
            &ldquo;From source to destination.&rdquo;
          </p>
          <p className="mt-3 text-sm text-[#6B4423]">
            DDGS &middot; Tea &middot; Spices &mdash; Nature&apos;s Best. World&apos;s Finest.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <p className="text-xs uppercase tracking-[0.2em] text-[#7A4E24]">Navigate</p>
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="link-underline w-fit text-sm text-[#3D2817]/80 hover:text-[#3D2817]"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="max-w-xs">
          <p className="text-xs uppercase tracking-[0.2em] text-[#7A4E24]">Reach Us</p>
          <p className="mt-3 text-sm leading-relaxed text-[#3D2817]">
            House No 21 B, P.B. Road, Rehabari, Guwahati, Assam &ndash; 781008
          </p>
          <a
            href="mailto:enquiry@agrotradeglobal.in"
            className="mt-3 block text-sm text-[#3D2817] link-underline w-fit"
          >
            enquiry@agrotradeglobal.in
          </a>
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-2 border-t border-[#DBCFA0] pt-6 text-xs text-[#6B4423] md:flex-row md:items-center md:justify-between">
        <span>&copy; {new Date().getFullYear()} Agro Trade Global LLP. All rights reserved.</span>
        <span>Guwahati, Assam, India</span>
      </div>
    </div>
  </footer>
);
